import axios from "axios";

const BASE_URL = "https://satkartarcrmcall.satkartar.me/";
//const BASE_URL = "http://localhost/satkartarcrmcall/";

export const loginAPI = async (url, params) => {
    try {
        const sendmobileotp = await axios({
            method: "post",
            url: BASE_URL + url,
            data: { mobile: params },
            headers: { "Content-Type": "multipart/form-data" },
        })
        return sendmobileotp;
    }
    catch (err) {
        return err;
    }
}

export const verifyMobileOTPAPI = async (url, params) => {
    try {
        const matchedmobileotp = await axios({
            method: "POST",
            url: BASE_URL + url,
            data: params,
            headers: { "Content-Type": "multipart/form-data" },
        })
        return matchedmobileotp;
    }
    catch (err) {
        return err;
    }
}

export const reSendMobileOTP = async (url, params) => {
    try {
        const resendOTP = await axios({
            method: "POST",
            url: BASE_URL + url,
            data: { mobile: params },
            headers: { "Content-Type": "multipart/form-data" },
        })
        return resendOTP;
    }
    catch (err) {
        return err;
    }
}

export const addDataAPI = async (url, params) => {
    try {
        const addHr = await axios({
            method: "POST",
            url: BASE_URL + url,
            data: params,
            headers: { "Content-Type": "multipart/form-data" },
        })
        return addHr;
    }
    catch (err) {
        return err;
    }
}
export const fetchAllDataAPI = async (url, params) => {
    try {
        const order = await axios({
            method: "get",
            url: BASE_URL + url,
            headers: { "Content-Type": "multipart/form-data" },
        })
        return order;
    }
    catch (err) {
        return err;
    }
}

export const activeStatus = async (url, params) => {
    try {
        const activeStatus = await axios({
            method: "POST",
            url: BASE_URL + url,
            data: { id: params },
            headers: { "Content-Type": "multipart/form-data" },
        })
        return activeStatus;
    }
    catch (err) {
        return err;
    }
}
export const deactiveStatus = async (url, params) => {
    try {
        const activeStatus = await axios({
            method: "POST",
            url: BASE_URL + url,
            data: { id: params },
            headers: { "Content-Type": "multipart/form-data" },
        })
        return activeStatus;
    }
    catch (err) {
        return err;
    }
}

export const removeDataFromList = async (url, params) => {
    try {
        const activeStatus = await axios({
            method: "POST",
            url: BASE_URL + url,
            data: { id: params },
            headers: { "Content-Type": "multipart/form-data" },
        })
        return activeStatus;
    }
    catch (err) {
        return err;
    }
}

export const editDataFromList = async (url, params) => {
    try {
        const editData = await axios({
            method: "GET",
            url: BASE_URL + url,
            data: { id: params },
            headers: { "Content-Type": "multipart/form-data" },
        })
        return editData;
    }
    catch (err) {
        return err;
    }
}
export const updateDataAPI = async (url, params) => {
    try {
        const updateData = await axios({
            method: "post",
            url: BASE_URL + url,
            data: params,
            headers: { "Content-Type": "multipart/form-data" },
        })
        return updateData;
    }
    catch (err) {
        return err;
    }
}
export const addFormData = async (url, params) => {
    try {
        const addData = await axios({
            method: "POST",
            url: BASE_URL + url,
            mimeType: "multipart/form-data",
            data: params,
            headers: { "Content-Type": "multipart/form-data" },
        })
        return addData;
    }
    catch (err) {
        return err;
    }
}
export const getSingleDataFromDatabase = async (url, params) => {
    try {
        const editData = await axios({
            method: "GET",
            url: BASE_URL + url,
            data: { id: params },
            headers: { "Content-Type": "multipart/form-data" },
        })
        return editData;
    }
    catch (err) {
        return err;
    }
}
export const userUploadProfilePicAPI = async (url, params) => {
    try {
        const profilePic = await axios({
            method: "post",
            url: BASE_URL + url,
            mimeType: "multipart/form-data",
            data: params,
            headers: { "Content-Type": "multipart/form-data" },
        })
        return profilePic;
    }
    catch (err) {
        return err;
    }
}
export const fetchAllDataByIDAPI = async (url, params) => {
    try {
        const order = await axios({
            method: "get",
            url: BASE_URL + url,
            data: { id: params },
            headers: { "Content-Type": "multipart/form-data" },
        })
        return order;
    }
    catch (err) {
        return err;
    }
}

export const fetchAllDashboardDataAPI = async (url) => {
    try {
        const order = await axios({
            method: "GET",
            url: BASE_URL + url,
            headers: { "Content-Type": "multipart/form-data" },
        })
        return order;
    }
    catch (err) {
        return err;
    }
}
export const filterByParams = async (url, params) => {
    try {
        const addData = await axios({
            method: "POST",
            url: BASE_URL + url,
            mimeType: "multipart/form-data",
            data: params,
            headers: { "Content-Type": "multipart/form-data" },
        })
        return addData;
    }
    catch (err) {
        return err;
    }
}
export const skillFilterByNameAPI = async (url, params) => {
    try {
        const skill = await axios({
            method: "POST",
            url: BASE_URL + url,
            data: params,
            headers: { "Content-Type": "multipart/form-data" },
        })
        return skill;
    }
    catch (err) {
        return err;
    }
}
export const fetchAllDataByAPI = async (url, params) => {
    try {
        const order = await axios({
            method: "POST",
            url: BASE_URL + url,
            data: params,
            headers: { "Content-Type": "multipart/form-data" },
        })
        return order;
    }
    catch (err) {
        return err;
    }
}

/*****************************
 * Facebook (Multi‑tenant) APIs
 *****************************/

// If your CI session/auth uses cookies, uncomment:
// axios.defaults.withCredentials = true;

/** Build OAuth connect URL (use for window.location.href) */
export const fbConnectUrl = (tenantId) =>
    BASE_URL + `auth/facebook/login/${tenantId}`;

/** GET /api/tenants  -> [{ id, name, slug }] */
export const fbListTenantsAPI = async (ppc_id) => {
    try {
        return await axios.get(BASE_URL + `api/tenants/${ppc_id}`);
    } catch (err) {
        return err;
    }
};

/** GET /api/facebook/connected?tenant_id=#  */
export const fbConnectedAPI = async (tenantId) => {
    try {
        return await axios.get(BASE_URL + "api/facebook/connected", {
            params: { tenant_id: tenantId },
            headers: { "Content-Type": "application/json" },
        });
    } catch (err) {
        return err;
    }
};

/** GET /api/facebook/health?tenant_id=# */
export const fbHealthAPI = async (tenantId) => {
    try {
        return await axios.get(BASE_URL + "api/facebook/health", {
            params: { tenant_id: tenantId },
            headers: { "Content-Type": "application/json" },
        });
    } catch (err) {
        return err;
    }
};

/** POST /api/facebook/page/{page_id}/subscribe */
export const fbSubscribePageAPI = async (pageId) => {
    try {
        return await axios.post(
            BASE_URL + `api/facebook/page/${pageId}/subscribe`,
            {},
            { headers: { "Content-Type": "application/json" } }
        );
    } catch (err) {
        return err;
    }
};

/** POST /api/facebook/forms/refresh?tenant_id=# */
export const fbRefreshFormsAPI = async (tenantId) => {
    try {
        return await axios.post(
            BASE_URL + `api/facebook/forms/refresh`,
            {},
            {
                params: { tenant_id: tenantId },
                headers: { "Content-Type": "application/json" },
            }
        );
    } catch (err) {
        return err;
    }
};

/** POST /api/facebook/forms/backfill  { form_id, since, until } */
export const fbBackfillFormAPI = async ({ form_id, since, until }) => {
    try {
        return await axios.post(
            BASE_URL + "api/facebook/forms/backfill",
            { form_id, since, until },
            { headers: { "Content-Type": "application/json" } }
        );
    } catch (err) {
        return err;
    }
};

/** POST /api/facebook/insights/pull  { ad_account_id, since, until, level } */
export const fbPullInsightsAPI = async ({
    ad_account_id,
    since,
    until,
    level = "campaign",
}) => {
    try {
        return await axios.post(
            BASE_URL + "api/facebook/insights/pull",
            { ad_account_id, since, until, level },
            { headers: { "Content-Type": "application/json" } }
        );
    } catch (err) {
        return err;
    }
};

// ============= NGUCC Call ========================

export const fetchCallAllDataByIDAPI = async (url, params) => {
    try {
        const order = await axios({
            method: "get",
            url: BASE_URL + url,
            data: { id: params },
            headers: { "Content-Type": "multipart/form-data" },
        })
        return order;
    }
    catch (err) {
        return err;
    }
}

export const filterCallByParams = async (url, params) => {
    try {
        const addData = await axios({
            method: "POST",
            url: BASE_URL + url,
            mimeType: "multipart/form-data",
            data: params,
            headers: { "Content-Type": "multipart/form-data" },
        })
        return addData;
    }
    catch (err) {
        return err;
    }
}

export const fetchProcessDetails = async (url, params) => {
    try {
        const addData = await axios({
            method: "POST",
            url: BASE_URL + url,
            mimeType: "multipart/form-data",
            data: params,
            headers: { "Content-Type": "multipart/form-data" },
        })
        return addData;
    }
    catch (err) {
        return err;
    }
}

export const addCallFormData = async (url, params) => {
    try {
        const addData = await axios({
            method: "POST",
            url: BASE_URL + url,
            mimeType: "multipart/form-data",
            data: params,
            headers: { "Content-Type": "multipart/form-data" },
        })
        return addData;
    }
    catch (err) {
        return err;
    }
}


/*****************************
 * Google Ads (Multi-tenant) APIs
 *****************************/

/** Build OAuth connect URL (use in window.location.href) */
export const googleAdsConnectUrl = (tenantId) =>
    BASE_URL + `googleads/connect?tenant_id=${tenantId}`;

/** GET /api/googleads/accounts?tenant_id=# 
 *  -> [{ customer_id, name, currency }]
 */
export const googleAdsListAccountsAPI = async (tenantId) => {
    try {
        return await axios.get(BASE_URL + "api/googleads/accounts", {
            params: { tenant_id: tenantId },
            headers: { "Content-Type": "application/json" },
        });
    } catch (err) {
        return err;
    }
};

/** GET /api/googleads/metrics?tenant_id=#&customer_id=#&from=YYYY-MM-DD&to=YYYY-MM-DD
 *  -> [{ date, campaignId, adGroupId, adId, impr, clicks, costMicros }]
 *  NOTE: costMicros / 1_000_000 = account-currency spend
 */
export const googleAdsFetchMetricsAPI = async ({
    tenant_id,
    customer_id,
    from,
    to,
}) => {
    try {
        return await axios.get(BASE_URL + "api/googleads/metrics", {
            params: { tenant_id, customer_id, from, to },
            headers: { "Content-Type": "application/json" },
        });
    } catch (err) {
        return err;
    }
};

export const googleListTenantsByPpcAPI = async (ppc_id) => {
    try {
        return await axios.get(BASE_URL + "api/googleads/tenants", {
            params: { ppc_id },
            headers: { "Content-Type": "application/json" },
        });
    } catch (err) {
        return err;
    }
};